export default __webpack_public_path__ + "static/media/16.542b17bb.jpg";